/////////////////////////////////////////////////////////////
import { useCustomSelector } from '@/core/redux/hooks';
import { FriendListItem } from './components';

interface FriendsListProps {}

export const FriendsList: React.FC<
	FriendsListProps
> = ({}: FriendsListProps) => {
	/*********************
	// #region Redux
	**********************/
	const { friends } = useCustomSelector((state) => state.friends);

	/*********************
	// #region Template
	**********************/
	return (
		<div className="mt-6 flex flex-col gap-2">
			{friends.map((friend) => {
				return <FriendListItem key={friend.name} friend={friend} />;
			})}
		</div>
	);
};
